import styled, { css } from "styled-components";
import { colours } from "../../../../../../styles/colours.constants";
import {
	satoshi700,
	satoshi900,
} from "../../../../../../styles/font.constants";

const ROW_Y_POS = [
	[],
	[],
	[],
	[0, 23, 25, 20],
	[0, 8, 7, 2, 10],
	[0, 17, 13, 3, -5, 17],
];

export const GridContainer = styled.div<{ $isViewer: boolean }>`
	position: relative;
	width: 100%;
	margin-top: 1rem;
	${({ $isViewer }) =>
		$isViewer &&
		css`
			transform: scale(0.9);
		`}
`;

export const RowsContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

type GridRowStyleProps = {
	$numRows: number;
	$rowIndex: number;
};

export const GridRow = styled.div<GridRowStyleProps>`
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	width: 70%;
	margin-top: ${({ $rowIndex, $numRows }) => ROW_Y_POS[$numRows][$rowIndex]}px;
`;

export const PlayerContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

export const PlayerCell = styled.div`
	width: 30px;
	height: 30px;
	border-radius: 20px;
	background-color: ${colours.yellowLight};
	border: solid 2px ${colours.black};
	display: flex;
	justify-content: center;
	align-items: center;
	${satoshi900}
	font-size: 13px;
	z-index: 5;
	cursor: default;
`;

export const PlayerName = styled.div`
	${satoshi700}
	color: ${colours.black};
	font-size: 0.7rem;
	z-index: 5;
	margin-top: 4px;
	cursor: default;
`;

export const FormationBackgroundImage = styled.img`
	position: absolute;
	left: 50%;
	top: 1rem;
	transform: translateX(-50%);
	z-index: 4;
`;
